import { Controller } from "stimulus"
//import $ from 'jquery';
import Rails from '@rails/ujs';

//https://www.youtube.com/watch?v=I5EvTSytDIM
let async_stream;

export default class extends Controller {
  static targets = ["button", "timer", "live", 'playback']

  initialize() {
    (async () => {
      let _this = this;
      let interval = null;

      const playButton = _this.buttonTarget;
      const liveVideo = _this.liveTarget;
      const playbackContainer = _this.playbackTarget;
      const playbackVideo = playback.querySelector("video");

      async_stream = navigator.mediaDevices.getUserMedia({ audio: true, video: true });
      const stream = await async_stream;

      

      if (liveVideo != null) {
        const dataTransfer = new DataTransfer();

        liveVideo.srcObject = stream;
        const recorder = new MediaRecorder(stream);
        const chunks = [];

        recorder.ondataavailable = (e) => {
          chunks.push(e.data);
        }



        playButton.addEventListener('click', function(e) {
          if (_this.buttonTarget.classList.contains("recording")) {
            e.preventDefault();
            // Stop recording
            recorder.stop();
            clearInterval(interval);

            playButton.classList.remove("recording", "toggle-label-active", "toggle-icon-active");

            setTimeout(() => {
              //let recordedBlob = new Blob(recordedChunks, { type: "video/webm" });
              if (playbackContainer != null && playbackVideo != null) {

                //INPUT
                const blob = new Blob(chunks, { type: recorder.mimeType });
                var file = new File([blob], "RecordedVideo.webm");

                dataTransfer.items.add(file);

                playbackContainer.querySelector('#uploadfield').files = dataTransfer.files; //dataTransfer.files;
                playbackContainer.querySelector('#uploadfield').dispatchEvent(new Event('change', { bubbles: true }));
                playbackContainer.querySelector('#uploadfield').dispatchEvent(new Event('input', { bubbles: true }));
                //END INPUT

                let recordedBlob = window.URL.createObjectURL(chunks[chunks.length - 1])

                playbackContainer.style.display = "flex";
                playbackVideo.src = recordedBlob;

                //Download btn
                playbackContainer.querySelector('#download').href = recordedBlob;
                playbackContainer.querySelector('#download').download = "RecordedVideo.webm";

                playbackVideo.play();
              }
              
            }, 500);

          } else {
            e.preventDefault();
            let startTime = Date.now();
            // Start recording
            recorder.start();

            playButton.classList.add("recording", "toggle-label-active", "toggle-icon-active");

            interval = window.setInterval(() => {
              _this.timerTarget.textContent = _this.msToHms(Date.now() - startTime);
            }, 0);

          }
          
        });

      }

  
    })();
  }

  disconnect() {
    async_stream
    .then(mediaStream => {

      const tracks = mediaStream.getTracks();

      tracks.forEach((track) => track.stop());
    })
  }

  msToHms(ms) {
    var s = parseInt(ms/1000);
    var h = parseInt(s/3600);
    var m = parseInt((s%3600)/60);
    s = s % 60

    return (h < 10 ? '0' : '') + h + ":" + (m < 10 ? '0' : '') + m + ":" + (s < 10 ? '0' : '') + s;
  }


} 
